import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'exam-event-examinee';

const ELEMENTS = define({
  IMPORT_BUTTON: ['import', 'button'],
});

export const EXAM_EVENT_EXAMINEE_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
